import { createSlice } from "@reduxjs/toolkit";
import {
  createOrderBuilder,
  getUserOrdersBuilder,
  getOrderByIdBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  // Current order being created
  currentOrder: null,
  orderLoading: false,
  
  // User's orders list
  orders: [],
  ordersLoading: false,
  
  // Selected order details
  selectedOrder: null,
  selectedOrderLoading: false,
  
  // Error handling
  error: null,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearCurrentOrder: (state) => {
      state.currentOrder = null;
    },
    clearSelectedOrder: (state) => {
      state.selectedOrder = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    createOrderBuilder(builder);
    getUserOrdersBuilder(builder);
    getOrderByIdBuilder(builder);

    builder.addCase(LOGOUT, () => ({ ...initialState }));
  },
});

export const { clearCurrentOrder, clearSelectedOrder, clearError } = ordersSlice.actions;

// Selectors
export const selectCurrentOrder = (state) => state.orders.currentOrder;
export const selectOrderLoading = (state) => state.orders.orderLoading;
export const selectOrders = (state) => state.orders.orders;
export const selectOrdersLoading = (state) => state.orders.ordersLoading;
export const selectSelectedOrder = (state) => state.orders.selectedOrder;
export const selectSelectedOrderLoading = (state) => state.orders.selectedOrderLoading;
export const selectOrdersError = (state) => state.orders.error;

export default ordersSlice.reducer;